module.exports = {
	"CD": {
		"title": "Musica Pro Sancta Cecilia  VII - Poezie Jana od Kříže",
		"info": {
			"cs-CZ": "Tato nahrávka je určena k poslechu především nevidomým a těžce zrakově znevýhodněným čtenářům. Celkový čas: 77 min.",
			"en-GB": "This recording is intended to be listened to primarily by blind and severely visually impaired readers. Total time: 77 min.",
			"fr-FR": "Cet enregistrement est destiné à être écouté principalement par des lecteurs aveugles ou souffrant d'une grave déficience visuelle. Durée totale : 77 min.",
			"de-DE": "Diese Aufnahme ist in erster Linie für blinde und stark sehbehinderte Leser bestimmt. Gesamtlänge: 77 Minuten."
		},
		"tracks": [
			{
				"title": "Úvodem"
			},
			{
				"title": "Kdysi za noci temné"
			},
			{
				"title": "hudební předěl I."
			},
			{
				"title": "Kam jsi se ukryl, milý"
			},
			{
				"title": "hudební předěl II."
			},
			{
				"title": "Milostný plameni"
			},
			{
				"title": "Vstoupil jsem a nevím kam"
			},
			{
				"title": "Žiji jako bez života"
			},
			{
				"title": "hudební předěl III."
			},
			{
				"title": "Cestou k milostnému boji"
			},
			{
				"title": "Pastýř je sám"
			},
			{
				"title": "Já o studnici vím"
			},
			{
				"title": "hudební předěl IV."
			},
			{
				"title": "Na počátku bylo slovo"
			},
			{
				"title": "Nekonečnou láskou veden"
			},
			{
				"title": "Nevěstu, jež láskou plane"
			},
			{
				"title": "Budiž, staň se, pravil otec"
			},
			{
				"title": "Pro naději pevné víry"
			},
			{
				"title": "hudební předěl V."
			},
			{
				"title": "Dlouze uplývají věky"
			},
			{
				"title": "Protože už přišla chvíle"
			},
			{
				"title": "Archanděla Gabriela"
			},
			{
				"title": "Když se přiblížila chvíle"
			},
			{
				"title": "hudební předěl VI."
			},
			{
				"title": "U břehů řek babylonských"
			},
			{
				"title": "S oporou i bez opory"
			},
			{
				"title": "Ani půvabům a kráse"
			},
			{
				"title": "hudební předěl VII."
			},
			{
				"title": "Slovem božím je"
			},
			{
				"title": "hudební předěl VIII."
			},
			{
				"title": "Úhrn dokonalosti"
			},
			{
				"title": "Závěr"
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/post04/CD08.json
// module id = 87
// module chunks = 0